import React from 'react';
import { ImageConstants } from '@shared/constants';
import { Tooltip } from '@paretogroup/tess';
import { CampaignRemovedIcon, useStyles } from './tooltip-switch.styles';

export const TooltipSwitch = () => {
    const classes = useStyles();

    return (
        <div>
            <Tooltip
                title="Status: removed"
                classes={{
                    tooltip: classes.tooltipStyleWrapper,
                    arrow: classes.tooltipStyleArrow,
                }}
                placement="top"
            >
                <CampaignRemovedIcon
                    src={ImageConstants.ICONS.CAMPAIGN_REMOVED.SRC}
                    data-tip="Status: removed"
                />
            </Tooltip>

        </div>
    );
};
